// ZavadyMobile — mview Závady (ústava 96.10). Výber zákazky → zavady.html (spoločná štruktúra s OMERAJ).
// Prístup: admin/majiteľ/majster (VIEW_MODE_TABS v MobileApp.jsx).
// Offline (audit 12.7. bod 7): zoznam zákaziek sa cachuje do localStorage — bez signálu sa dá vojsť.
import React, { useEffect, useState } from 'react'

const C = { line: '#e7e2db', muted: '#8a8278', ink: '#1f2937', red: '#dc2626' }
const LS_KEY = 'zavady_projects_cache'

export default function ZavadyMobile() {
  const [projects, setProjects] = useState(null)
  const [sel, setSel] = useState(null)
  const [fromCache, setFromCache] = useState(false)

  useEffect(() => {
    fetch('/api/projects?scope=all', { headers: { Authorization: `Bearer ${localStorage.getItem('kamir_token') || ''}` } })
      .then(r => { if (!r.ok) throw 0; return r.json() })
      .then(d => {
        const list = (Array.isArray(d) ? d : []).filter(p => p.status !== 'dokoncena' && p.status !== 'archived')
        setProjects(list)
        try { localStorage.setItem(LS_KEY, JSON.stringify(list)) } catch (e) {}
      })
      .catch(() => {
        try { const c = JSON.parse(localStorage.getItem(LS_KEY) || '[]'); setProjects(Array.isArray(c) ? c : []); setFromCache(true) }
        catch (e) { setProjects([]); setFromCache(true) }
      })
  }, [])

  if (sel) return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 'calc(100vh - 150px)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', borderBottom: `1px solid ${C.line}`, background: '#fff' }}>
        <button onClick={() => setSel(null)} style={{ padding: '9px 14px', minHeight: 42, fontSize: 14, border: `1px solid ${C.line}`, background: '#fff', borderRadius: 9, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700 }}>← Zákazky</button>
        <div style={{ fontSize: 13.5, fontWeight: 700, color: C.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{sel.name}</div>
      </div>
      {(() => { const cu = window.location.protocol === 'https:' ? 'https://control.ksbx.sk' : ('http://' + window.location.hostname + ':8092');
        return <iframe src={cu + '/?embed=1&project_id=' + encodeURIComponent(sel.id)} title="Závady (CONTROL)"
          onLoad={e => { try { e.target.contentWindow.postMessage({ type: 'kamir-token', token: localStorage.getItem('kamir_token') || '', project: { id: sel.id, name: sel.name, zakazka_code: sel.zakazka_code || '' } }, cu); } catch (_) {} }}
          style={{ flex: 1, width: '100%', border: 'none', display: 'block', minHeight: 'calc(100vh - 200px)' }} />; })()}
    </div>
  )

  if (projects === null) return <div style={{ padding: 20, color: C.muted }}>Načítavam zákazky…</div>
  return (
    <div style={{ padding: 12 }}>
      <div style={{ fontSize: 13, color: C.muted, marginBottom: 10 }}><b>Závady na pláne</b> — vyber zákazku.{fromCache ? ' (offline zoznam)' : ''}</div>
      {projects.length === 0 && <div style={{ color: C.muted, padding: 12 }}>{navigator.onLine ? 'Žiadne aktívne zákazky.' : 'Bez signálu a bez uloženého zoznamu — otvor Závady raz so signálom.'}</div>}
      {projects.map(p => (
        <div key={p.id} onClick={() => setSel(p)} style={{ background: '#fff', border: `1px solid ${C.line}`, borderRadius: 12, padding: '13px 14px', marginBottom: 8, cursor: 'pointer' }}>
          <div style={{ fontSize: 12, color: C.muted, fontFamily: 'monospace' }}>{p.zakazka_code || p.id}</div>
          <div style={{ fontSize: 15, fontWeight: 700, color: C.ink }}>{p.name}</div>
        </div>
      ))}
    </div>
  )
}
